import get from 'just-safe-get';
import set from 'just-safe-set';
import {
  // eslint-disable-next-line import/named
  OnErrorHandler, TaggingFields, TaggingParser, TValue,
} from './typings';

function getDataFromInput(key: string, data: Record<string, TValue>, defaultValue?: TValue, onError?: OnErrorHandler | undefined) {
  const value = get(data, key, defaultValue);
  if (value === undefined) {
    if (onError) {
      onError(`key: "${key}" does not exists on input data with keys: [${Object.keys(data)}]`);
    }
  }
  return value;
}

// eslint-disable-next-line import/prefer-default-export
export const createParser = (config: TaggingFields): TaggingParser => ({ data, flowType, eventName }, onError) => {
  const { fields } = config;
  if (!data) return {};
  return fields.reduce((acc, {
    from, to, validate, transform,
  }) => {
    const value = get(data, from);

    const transformedValue = transform ? transform(value, {
      getInputValue: (key: string, defaultValue?: TValue) => getDataFromInput(key, data, defaultValue, onError),
      getFlowType: () => flowType,
      getEventName: () => eventName,
    }) : value;

    let isValid = true;
    let validatorName = null;
    for (let i = 0; i < validate.length; i += 1) {
      const validator = validate[i];
      if (!validator(transformedValue)) {
        isValid = false;
        validatorName = 'no-name';
        break;
      }
    }

    if (!isValid && onError) {
      onError(`${validatorName}: Invalid value for ${from}: ${transformedValue}`);
    }
    set(acc, to, transformedValue);
    return acc;
  }, {});
};
